import { useMemo, useCallback } from "react";

/*
Groups site form state into a stable, memoized object for consumption by presentational components.
This hook does not fetch data nor manage state; it only groups provided values and setters.
*/
export const useSiteFormState = ({ values = {}, set = {}, helpers = {}, lists = {} }) => {
  const memoValues = useMemo(
    () => ({ ...values }),
    [
      values.name,
      values.address1,
      values.city,
      values.usState,
      values.zip,
      values.country,
      values.timezone,
      values.latitude,
      values.longitude,
      values.siteState,
      values.siteNotifications,
      values.contractType,
      values.dealStructure,
      values.billSavingsProvider,
      values.gridServicesProvider,
      values.commissionedDate,
      values.contractEndDate,
      values.dateAcquired,
      values.sgipBudgetCategory,
      values.sgipStartDate,
      values.sgipCapacity,
      // connections
      values.utility,
      values.gasUtility,
      values.iso,
      values.postTariffSame,
    ],
  );

  const memoSetters = useMemo(() => ({ ...set }), [set]);

  const allFieldsFilled = helpers?.allFieldsFilled || (() => true);
  const setDirty = helpers?.setDirty || (() => {});
  const dirty = helpers?.dirty ?? false;

  const memoHelpers = useMemo(
    () => ({ dirty, setDirty, allFieldsFilled }),
    [dirty, setDirty, allFieldsFilled],
  );

  const memoLists = useMemo(() => ({ ...lists }), [lists]);

  return useMemo(
    () => ({
      form: { values: memoValues, set: memoSetters, helpers: memoHelpers },
      lists: memoLists,
    }),
    [memoValues, memoSetters, memoHelpers, memoLists],
  );
};

export default useSiteFormState;
